import clsx from 'clsx';

const colorClassNames = {
  red: 'bg-tag-red text-tag-red',
  gray: 'bg-tag-gray text-tag-gray',
  orange: 'bg-tag-orange text-tag-orange',
} as const;

type MailStatusTagProps = {
  color: keyof typeof colorClassNames;
  children: string;
};

export default function MailStatusTag({ color, children }: MailStatusTagProps) {
  return (
    <span
      className={clsx(
        'inline-flex h-5 shrink-0 items-center rounded-sm px-sm text-tag-sm font-bold whitespace-nowrap',
        colorClassNames[color]
      )}
    >
      {children}
    </span>
  );
}
